var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCourse3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 468 468",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0b1226",
    d: "M277.671 364.54H160.236l18.825-71.026h79.785z",
    opacity: 1,
    "data-original": "#0b1226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#192f5c",
    d: "M297.216 387.364H140.691v-15.502c0-8.146 6.604-14.75 14.75-14.75h127.024c8.146 0 14.75 6.604 14.75 14.75v15.502zM420.575 301.281H17.332c-8.146 0-14.75-6.604-14.75-14.75V33.193c0-8.146 6.604-14.75 14.75-14.75h403.244c8.146 0 14.75 6.604 14.75 14.75V286.53c0 8.147-6.604 14.751-14.751 14.751z",
    opacity: 1,
    "data-original": "#192f5c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M415.925 37.843V281.88H21.981V37.843z",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#61ceac",
    d: "M333.234 158.152a79.76 79.76 0 0 0-54.516 0V89.927a79.76 79.76 0 0 1 54.516 0z",
    opacity: 1,
    "data-original": "#61ceac"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52c1a1",
    d: "M387.75 158.152a79.76 79.76 0 0 0-54.516 0V89.927a79.76 79.76 0 0 1 54.516 0z",
    opacity: 1,
    "data-original": "#52c1a1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e8f9",
    d: "M57.783 73.342h198.23V245.79H57.783z",
    opacity: 1,
    "data-original": "#f0e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#865acc",
    d: "M102.785 120.446V243.81h118.256V120.858l-55.269-13.71z",
    opacity: 1,
    "data-original": "#865acc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M185.837 145.7h-38.886a9.911 9.911 0 0 0-9.717 7.957l-10.047 49.93c-1.235 6.137 3.458 11.867 9.717 11.867h38.886a9.911 9.911 0 0 0 9.717-7.957l10.047-49.93c1.236-6.136-3.457-11.867-9.717-11.867z",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M151.88 12.696s6.633-16.527 31.388-1.382c0 0 27.211 16.768 13.393 46.183l-68.25-.355c-8.902-53.544 23.469-44.446 23.469-44.446z",
    opacity: 1,
    "data-original": "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M151.835 12.684c-1.276-.338-32.142-7.982-23.424 44.458h9.896c-5.528-33.25 4.859-42.341 13.528-44.458z",
    opacity: 1,
    "data-original": "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#865acc",
    d: "m162.769 101.257 9.892-.016h-48.49c-1.456 0-2.911-.03-4.367-.048-5.891-.073-32.377 2.278-39.554 48.756-5.546 35.915-2.7 55.527 1.511 66.155 3.463 8.738 12.773 13.859 21.981 11.975 20.952-4.287 42.587-25.777 49.271-32.883l6.881-1.146c5.425-1.122 13.622-2.703 20.215-11.289 11.148-14.516-11.876-23.607-19.569-15.141l1.203-5.246c.585-2.552-1.267-5.065-3.928-5.329-1.72-.171-3.362.659-4.201 2.128-2.66 4.657-8.34 14.029-10.389 16.904l-33.505 17.417c6.937-17.984 5.166-50.229 5.166-50.229",
    opacity: 1,
    "data-original": "#865acc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6a42ba",
    d: "M93.638 216.103c-4.212-10.628-7.057-30.24-1.511-66.155 6.612-42.819 29.613-48.185 37.799-48.707h-5.754c-1.456 0-2.911-.031-4.367-.049-5.891-.072-32.377 2.278-39.554 48.756-5.546 35.915-2.7 55.527 1.511 66.155 3.463 8.738 12.773 13.86 21.981 11.976a42.153 42.153 0 0 0 2.233-.526c-5.473-1.73-10.114-5.837-12.338-11.45z",
    opacity: 1,
    "data-original": "#6a42ba"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#865acc",
    d: "M206.977 143.576s18.539 82.522 57.072 66.253c7.596-3.207 13.476-9.489 16.594-17.122l15.341-37.557 3.943-3.736c4.137-3.684 10.445-9.152 11.863-19.884 2.396-18.145-22.088-14.506-24.517-3.328l-1.582-5.145c-.769-2.502-3.63-3.753-6.066-2.651-1.575.712-2.582 2.252-2.574 3.943.02 4.275-.363 12.079-.69 16.854l-18.663 32.481c-6.709-12.459-12.033-25.595-16.274-39.095-9.948-31.665-30.903-33.46-36.061-33.397-1.456.018-52.857.048-52.857.048l9.892.016",
    opacity: 1,
    "data-original": "#865acc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9a395",
    d: "M162.061 120.042h1.581c8.146 0 14.75-6.604 14.75-14.75V79.336h-31.081v25.956c0 8.146 6.603 14.75 14.75 14.75z",
    opacity: 1,
    "data-original": "#f9a395"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc0b3",
    d: "M195.379 50.531c-1.679-1.406-3.959.134-5.769 1.946V39.758a8.142 8.142 0 0 0-8.142-8.142h-37.233a8.142 8.142 0 0 0-8.142 8.142v12.78c-1.779-1.838-4.04-3.429-5.7-2.007-7.152 6.125-.481 21.697 5.853 21.366 1.422 13.439 12.79 23.911 26.607 23.911s25.185-10.473 26.607-23.913c6.456.225 13.21-15.259 5.919-21.364zM160.542 167.62l1.203-5.246c.585-2.552-1.267-5.065-3.928-5.329-1.72-.171-3.362.659-4.201 2.128-2.66 4.657-8.34 14.029-10.389 16.904l-33.505 17.417c3.399-8.813 4.705-21.046 5.156-31.236-15.272 2.688-28.98 1.324-36.297.148-3.158 28.117-.515 44.369 3.181 53.697 3.463 8.738 12.773 13.859 21.981 11.975 20.952-4.287 42.587-25.777 49.271-32.883l6.881-1.146c5.425-1.122 13.622-2.703 20.215-11.289 11.149-14.515-11.875-23.606-19.568-15.14z",
    opacity: 1,
    "data-original": "#ffc0b3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9a395",
    d: "M93.638 216.103c-3.642-9.189-6.257-25.106-3.315-52.461a113.086 113.086 0 0 1-11.742-1.236c-1.471 20.957-7.586 69.281 25.185 65.667a43.306 43.306 0 0 0 2.21-.52c-5.473-1.73-10.114-5.837-12.338-11.45z",
    opacity: 1,
    "data-original": "#f9a395"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc0b3",
    d: "m287.273 128.203-1.582-5.145c-.769-2.502-3.63-3.753-6.066-2.651-1.575.713-2.582 2.251-2.574 3.943.02 4.275-.363 12.079-.69 16.854l-18.663 32.481c-4.437-8.239-8.256-16.779-11.569-25.52l-.027.083c-11.882 9.964-24.437 15.638-31.362 18.278h-.737c8.593 23.068 25.143 53.818 50.047 43.303 7.596-3.207 13.476-9.489 16.594-17.121l15.341-37.557 3.943-3.736c4.137-3.684 10.445-9.152 11.863-19.885 2.395-18.145-22.089-14.506-24.518-3.327z",
    opacity: 1,
    "data-original": "#ffc0b3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc31a",
    d: "M65.788 339.367H41.343c-5.819 0-10.536 4.717-10.536 10.536v112.159A5.938 5.938 0 0 0 36.745 468h33.64a5.938 5.938 0 0 0 5.938-5.938V349.903c0-5.818-4.717-10.536-10.535-10.536z",
    opacity: 1,
    "data-original": "#ffc31a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaf00",
    d: "M52.58 339.367H40.704c-5.466 0-9.896 4.431-9.896 9.896v112.798a5.938 5.938 0 1 0 11.876 0V349.264c-.001-5.466 4.43-9.897 9.896-9.897z",
    opacity: 1,
    "data-original": "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e8f9",
    d: "M30.807 448.21v13.852A5.938 5.938 0 0 0 36.745 468h33.64a5.938 5.938 0 0 0 5.938-5.938V448.21z",
    opacity: 1,
    "data-original": "#f0e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e2d2f7",
    d: "M30.807 448.21h11.876V468H30.807z",
    opacity: 1,
    "data-original": "#e2d2f7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M53.565 430.527a2.107 2.107 0 0 1-2.107-2.107v-69.263a2.107 2.107 0 1 1 4.214 0v69.263a2.107 2.107 0 0 1-2.107 2.107z",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f955af",
    d: "M111.84 339.367H86.323c-5.523 0-10 4.477-10 10v112.997A5.636 5.636 0 0 0 81.959 468h34.244a5.636 5.636 0 0 0 5.636-5.636V349.367c.001-5.522-4.477-10-9.999-10z",
    opacity: 1,
    "data-original": "#f955af"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef009f",
    d: "M98.096 339.367H86.22c-5.466 0-9.896 4.431-9.896 9.896v112.798a5.938 5.938 0 1 0 11.876 0V349.264c-.001-5.466 4.43-9.897 9.896-9.897z",
    opacity: 1,
    "data-original": "#ef009f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e8f9",
    d: "M76.323 448.21v13.852A5.938 5.938 0 0 0 82.261 468h33.64a5.938 5.938 0 0 0 5.938-5.938V448.21z",
    opacity: 1,
    "data-original": "#f0e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e2d2f7",
    d: "M76.323 448.21h11.876V468H76.323z",
    opacity: 1,
    "data-original": "#e2d2f7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M99.081 430.527a2.107 2.107 0 0 1-2.107-2.107v-69.263a2.107 2.107 0 1 1 4.214 0v69.263a2.106 2.106 0 0 1-2.107 2.107z",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#61ceac",
    d: "m153.406 346.476-23.611 6.327c-5.621 1.506-8.956 7.283-7.45 12.904l25.278 94.338c1.506 5.621 7.283 8.956 12.904 7.45l23.611-6.327c5.621-1.506 8.956-7.283 7.45-12.904l-25.278-94.338c-1.506-5.621-7.283-8.956-12.904-7.45z",
    opacity: 1,
    "data-original": "#61ceac"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52c1a1",
    d: "m159.664 457.693-25.609-95.573c-1.415-5.279 1.718-10.706 6.998-12.121l14.969-4.011a9.948 9.948 0 0 0-1.998.322l-24.847 6.658c-5.279 1.414-8.412 6.841-6.998 12.12l25.609 95.573c1.415 5.279 6.841 8.412 12.121 6.998l9.878-2.647c-4.588.267-8.887-2.706-10.123-7.319z",
    opacity: 1,
    "data-original": "#52c1a1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0e8f9",
    d: "m189.193 439.326-43.965 11.781 2.561 9.558c1.414 5.279 6.84 8.411 12.119 6.997l24.85-6.658c5.279-1.414 8.411-6.84 6.997-12.118z",
    opacity: 1,
    "data-original": "#f0e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e2d2f7",
    d: "m159.665 457.695-2.561-9.558-11.876 2.969 2.561 9.558c1.414 5.279 6.84 8.411 12.119 6.997l9.878-2.647c-4.587.266-8.886-2.707-10.121-7.319z",
    opacity: 1,
    "data-original": "#e2d2f7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M162.087 428.208c-.93 0-1.782-.621-2.034-1.563L144.688 369.3a2.107 2.107 0 0 1 1.49-2.58 2.102 2.102 0 0 1 2.58 1.49l15.366 57.345c.374 1.313-.678 2.67-2.037 2.653z",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f955af",
    d: "M375.378 284.726c-.656 16-2.786 34.669-8.538 47.453-12.025 26.729-12.601 48.434-12.601 48.434h-17.336v-29.632c0-11.073.911-22.122 2.732-33.044 2.715-16.287 6.598-43.667 7.49-71.371 1.034-32.148 38.227-30.223 57.706-26.99 7.283 1.209 14.59 2.221 21.915 3.143 14.599 1.837 39.503 8.641 38.651 33.695l.022 43.326c.009 16.865-1.781 33.702-5.666 50.11-1.812 7.652-7.855 23.875-10.394 28.766",
    opacity: 1,
    "data-original": "#f955af"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f955af",
    d: "M446.655 357.088c-4.692-14.141-9.991-29.589-10.922-45.404l-75.194-37.597-8.051 59.535-8.541 41.573c-8.714 18.204-6.774 58.212-3.95 92.66h111.087c3.782-20.779 9.708-68.162-4.429-110.767z",
    opacity: 1,
    "data-original": "#f955af"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff33a8",
    d: "M436.422 297.515c.882 23.495 7.52 43.043 12.212 57.185",
    opacity: 1,
    "data-original": "#ff33a8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef009f",
    d: "M448.634 356.807a2.11 2.11 0 0 1-2-1.445l-.294-.888c-4.705-14.169-11.148-33.574-12.023-56.88a2.107 2.107 0 1 1 4.211-.158c.853 22.707 7.187 41.782 11.811 55.712l.295.888a2.108 2.108 0 0 1-2 2.771z",
    opacity: 1,
    "data-original": "#ef009f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc0b3",
    d: "M442.22 341.051c1.436 4.658 2.966 9.217 4.436 13.648a166.777 166.777 0 0 1 4.972 18.567c3.043-7.517 6.856-18.057 8.125-23.417a204.094 204.094 0 0 0 1.574-7.311c-3.655-1.523-10.794-2.579-19.107-1.487z",
    opacity: 1,
    "data-original": "#ffc0b3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f955af",
    d: "M375.378 284.726c-.656 16-2.786 34.669-8.538 47.453-12.025 26.729-12.601 48.434-12.601 48.434h-17.336v-29.632c0-11.086.916-22.145 2.738-33.079 2.714-16.292 6.593-43.652 7.484-71.336",
    opacity: 1,
    "data-original": "#f955af"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef009f",
    d: "M347.125 246.565c-.891 27.704-4.775 55.084-7.49 71.371a201.012 201.012 0 0 0-2.732 33.044h11.876c0-11.073.911-22.122 2.732-33.044 2.715-16.287 6.598-43.667 7.49-71.371.67-20.827 16.516-27.346 32.89-28.481-19.607-1.203-43.933 2.567-44.766 28.481zM352.261 382.719h-.058a2.108 2.108 0 0 1-2.05-2.162c.024-.903.726-22.436 12.787-49.242 4.635-10.303 7.524-26.444 8.354-46.676a2.12 2.12 0 0 1 2.192-2.019 2.106 2.106 0 0 1 2.019 2.192c-.864 21.06-3.799 37.288-8.722 48.232-11.691 25.987-12.411 47.413-12.417 47.626a2.107 2.107 0 0 1-2.105 2.049z",
    opacity: 1,
    "data-original": "#ef009f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc0b3",
    d: "m325.209 386.07 6.682-9.949 2.459-3.655a15.002 15.002 0 0 0 2.553-8.373v-13.112c0-4.365.147-8.725.431-13.076 10.194-4.975 21.332-1.28 26.636 1.097-4.809 12.226-7.247 22.987-8.479 30.501-.54 3.29-.472 6.637.157 9.911 1.085 5.645 2.179 15.633-2.157 20.944-10.823 13.256-23.687-1.953-18.882-11.232l-4.078 2.774c-2.215 1.507-5.329.458-6.027-2.289-.309-1.214.008-2.503.705-3.541zM372.555 206.296s-27.278.668-10.627-49.619 10.627 49.619 10.627 49.619z",
    opacity: 1,
    "data-original": "#ffc0b3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M452.664 247.582c-2.254-3.248-4.294-6.631-5.972-10.21-4.233-9.028-10.351-24.198-9.088-34.177 1.528-12.075 1.813-25.676 1.866-30.512a33.646 33.646 0 0 0-.119-3.493c-3.617-38.906-43.224-38.195-43.224-38.195s-41.769-.001-33.627 29.729c7.343 26.814 6.701 37.318 1.469 65.075-1.996 10.591 1.852 13.998 7.106 11.915l-.002.006c-.267 4.255-.697 10.549.31 20.804 2.233 22.739 23.894 6.771 23.894 6.771 3.528 4.777 9.141 9.841 14.565 9.843 15.549.007 18.485-11.008 18.485-11.008 5.268 5.515 12.759 9.848 21.035 3.817 10.15-7.398 6.281-16.071 3.302-20.365z",
    opacity: 1,
    "data-original": "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M381.278 258.523c-.737-7.501-1.638-16.493-1.965-22.446-.112-2.044-1.771-3.541-3.809-3.73-1.455-.135-2.576-1.581-1.639-6.549 5.232-27.758 5.874-38.261-1.469-65.075-6.357-23.211 17.708-28.3 28.567-29.416-2.964-.347-4.836-.314-4.836-.314s-41.769-.001-33.627 29.729c7.343 26.814 6.701 37.318 1.469 65.075-1.996 10.591 1.852 13.998 7.106 11.915l-.002.006c-.267 4.255-.697 10.549.31 20.804 1.292 13.153 9.085 13.355 15.425 11.188-2.763-1.501-4.906-4.831-5.53-11.187z",
    opacity: 1,
    "data-original": "#212121"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.936,
    cy: 40.036,
    r: 40.036,
    fill: "#ffaf00",
    opacity: 1,
    "data-original": "#ffaf00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m395.591 43.5 26.524 15.314c2.667 1.54 6-.385 6-3.464V24.723c0-3.079-3.333-5.004-6-3.464l-26.524 15.314c-2.667 1.539-2.667 5.388 0 6.927z",
    opacity: 1,
    "data-original": "#ffffff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse3);
export default __webpack_public_path__ + "static/media/course-3.74449c6d958793e563b6475b168a7e53.svg";
export { ForwardRef as ReactComponent };